/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
import e from"../core/Error.js";function o(o){if(o&&"object"==typeof o&&"type"in o&&"mesh"===o.type)throw new e("internal:mesh","Mesh geometries are not supported for this operation")}function r(e){e.forEach(o)}export{o as assertNotMesh,r as assertNotMeshes};
